export function getFileSize(bytes: number) {
  const k = 1024;
  const dm = 3;
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  if (sizes) {
    if (bytes === 0) {
      return `0 ${sizes[0]}`;
    }

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedSize = (bytes / Math.pow(k, i)).toFixed(dm);

    return `${formattedSize} ${sizes[i]}`;
  }

  return "";
}

export function getFileName(filename: string) {
  return filename.replace(/ /g, "-");
}
